<template>
  <gd-modal name="dashboard-setting" width="50%" bg-type="dark">
    <div class="h-full">
      <div class="flex flex-row justify-between p-4">
        <div class="h-full font-bold text-xl text-grey-700">
          {{ $t('frontend_baselayout_dashboard_settings') }}
        </div>
        <div class="flex flex-row justify-end">
          <gd-button class="mr-4" @click="close">
            {{ $t('frontend_exit') }}
          </gd-button>
          <gd-button class="mr-4" @click="UpdateAddSetting">
            {{ $t('frontend_bouses_update') }}
          </gd-button>
        </div>
      </div>
      <div style="height: calc(100vh - 130px)" class="w-full overflow-y-auto">
        <div class="p-4">
          <div class="w-full flex flex-row pb-4">
            <div class="w-1/5 flex flex-col">
              <label class="font-semibold text-sm text-grey-700 mr-2">{{
                $t('frontend_gduikit_enable_ad')
              }}</label>
            </div>
            <div class="w-1/7 flex flex-col">
              <gd-toggle
                v-model="model.is_dashboard_ad_enabled"
                :value="model.is_dashboard_ad_enabled"
              />
            </div>
          </div>
          <div v-if="model.is_dashboard_ad_enabled">
            <div class="w-full flex flex-row pb-4">
              <div class="w-1/5 flex flex-col">
                <label class="font-semibold text-sm text-grey-700 mr-2">
                  Ad Setting Type
                </label>
              </div>
              <div class="w-1/2 flex flex-row">
                <label
                  ><input
                    v-model="model.dashboard_setting_type"
                    class=""
                    type="radio"
                    name="setting_btn"
                    value="1"
                  />
                  Normal Ad</label
                >
                <label
                  ><input
                    v-model="model.dashboard_setting_type"
                    class="ml-4"
                    type="radio"
                    name="setting_btn"
                    value="2"
                  />
                  Iframe URL</label
                >
              </div>
            </div>

            <div v-if="model.dashboard_setting_type == 1">
              <div class="w-full flex flex-row pb-4">
                <div class="w-1/5 flex flex-col">
                  <label class="font-semibold text-sm text-grey-700 mr-2">
                    {{
                      $t('frontend_baselayout_dashboard_setting_ad_video_link')
                    }}</label
                  >
                </div>
                <div class="w-1/2 flex flex-col">
                  <text-input
                    :placeholder="
                      $t('frontend_baselayout_dashboard_setting_ad_video_link')
                    "
                    class="w-full"
                    v-model.trim="model.dashboard_ad_video_embed"
                  />
                </div>
              </div>
              <div class="w-full flex flex-row pb-4">
                <div class="w-1/5 flex flex-col">
                  <label class="font-semibold text-sm text-grey-700 mr-2">
                    {{
                      $t('frontend_dash_sett_paid_users_ad_video_link')
                    }}</label
                  >
                </div>
                <div class="w-1/2 flex flex-col">
                  <text-input
                    placeholder="Paid Users Ad Video Link"
                    class="w-full"
                    v-model.trim="model.dashboard_ad_paid_video_embed"
                  />
                </div>
              </div>
              <div class="w-full flex flex-row pb-4">
                <div class="w-1/5 flex flex-col">
                  <label class="font-semibold text-sm text-grey-700 mr-2">
                    {{ $t('frontend_groovevideo_videos_step3_heading') }}</label
                  >
                </div>
                <div class="w-1/2 flex flex-col">
                  <text-input
                    :placeholder="
                      $t('frontend_groovevideo_videos_step3_heading')
                    "
                    class="w-full"
                    v-model.trim="model.dashboard_ad_heading"
                  />
                </div>
              </div>
              <div class="w-full flex flex-row pb-4">
                <div class="w-1/5 flex flex-col">
                  <label class="font-semibold text-sm text-grey-700 mr-2">
                    {{
                      $t('frontend_baselayout_dashboard_setting_ad_description')
                    }}
                  </label>
                </div>
                <div class="w-1/2 flex flex-col">
                  <text-area
                    v-model="model.dashboard_ad_description"
                    class="w-full"
                    value="model.dashboard_ad_description"
                    :placeholder="
                      $t('frontend_baselayout_dashboard_setting_ad_description')
                    "
                  />
                </div>
              </div>
              <div class="w-full flex flex-row pb-4">
                <div class="w-1/5 flex flex-col">
                  <label class="font-semibold text-sm text-grey-700 mr-2">
                    {{ $t('frontend_gduikit_ads_type') }}
                  </label>
                </div>
                <div class="w-1/2 flex flex-row">
                  <label
                    ><input
                      v-model="model.dashboard_ad_type"
                      class=""
                      type="radio"
                      name="filter_btn"
                      value="0"
                    />
                    {{ $t('frontend_text') }}</label
                  >
                  <label
                    ><input
                      v-model="model.dashboard_ad_type"
                      class="ml-4"
                      type="radio"
                      name="filter_btn"
                      value="1"
                    />
                    {{ $t('frontend_images') }}</label
                  >
                </div>
              </div>
              <!-- Link 1 -->
              <div
                class="w-full flex flex-row pb-4"
                v-if="model.dashboard_ad_type == 1"
              >
                <div class="w-1/5 flex flex-col">
                  <label class="font-semibold text-sm text-grey-700 mr-2">
                    {{
                      $t(
                        'frontend_baselayout_dashboard_setting_dashboard_ad_link1_image'
                      )
                    }}</label
                  >
                </div>
                <div class="w-1/2 flex flex-col">
                  <image-picker
                    v-model="model.dashboard_ad_link1_image"
                    :primary="true"
                  ></image-picker>
                </div>
              </div>
              <div class="w-full flex flex-row pb-4" v-else>
                <div class="w-1/5 flex flex-col">
                  <label class="font-semibold text-sm text-grey-700 mr-2">
                    {{
                      $t(
                        'frontend_baselayout_dashboard_setting_dashboard_ad_link1_title'
                      )
                    }}</label
                  >
                </div>
                <div class="w-1/2 flex flex-col">
                  <text-input
                    :placeholder="
                      $t(
                        'frontend_baselayout_dashboard_setting_dashboard_ad_link1_title'
                      )
                    "
                    class="w-full"
                    v-model.trim="model.dashboard_ad_link1_title"
                  />
                </div>
              </div>
              <div class="w-full flex flex-row pb-4">
                <div class="w-1/5 flex flex-col">
                  <label class="font-semibold text-sm text-grey-700 mr-2">
                    {{
                      $t(
                        'frontend_baselayout_dashboard_setting_dashboard_ad_link1'
                      )
                    }}</label
                  >
                </div>
                <div class="w-1/2 flex flex-col">
                  <text-input
                    :placeholder="
                      $t(
                        'frontend_baselayout_dashboard_setting_dashboard_ad_link1'
                      )
                    "
                    class="w-full"
                    v-model.trim="model.dashboard_ad_link1"
                  />
                </div>
              </div>
              <div class="w-full flex flex-row pb-4">
                <div class="w-1/5 flex flex-col">
                  <label class="font-semibold text-sm text-grey-700 mr-2">
                    {{ $t('frontend_display') }}</label
                  >
                </div>
                <div class="w-1/2 flex flex-col">
                  <select
                    v-model="model.dashboard_ad_link1_display"
                    class="
                        h-10
                        outline-none
                        rounded-lg
                        border
                        px-2
                        border-grey-200
                        max-w-full
                    "
                    :value="model.dashboard_ad_link1_display"
                  >
                    <option value="0">{{
                      $t('frontend_gduikit_show_to_all')
                    }}</option>
                    <option value="1">{{
                      $t('frontend_gduikit_show_only_to_free')
                    }}</option>
                    <option value="2">{{
                      $t('frontend_gduikit_show_only_to_paid')
                    }}</option>
                  </select>
                </div>
              </div>

              <!-- Link 2 -->
              <div
                class="w-full flex flex-row pb-4"
                v-if="model.dashboard_ad_type == 1"
              >
                <div class="w-1/5 flex flex-col">
                  <label class="font-semibold text-sm text-grey-700 mr-2">
                    {{
                      $t(
                        'frontend_baselayout_dashboard_setting_dashboard_ad_link2_image'
                      )
                    }}</label
                  >
                </div>
                <div class="w-1/2 flex flex-col">
                  <image-picker
                    v-model="model.dashboard_ad_link2_image"
                    :primary="true"
                  ></image-picker>
                </div>
              </div>
              <div class="w-full flex flex-row pb-4" v-else>
                <div class="w-1/5 flex flex-col">
                  <label class="font-semibold text-sm text-grey-700 mr-2">
                    {{
                      $t(
                        'frontend_baselayout_dashboard_setting_dashboard_ad_link2_title'
                      )
                    }}</label
                  >
                </div>
                <div class="w-1/2 flex flex-col">
                  <text-input
                    :placeholder="
                      $t(
                        'frontend_baselayout_dashboard_setting_dashboard_ad_link2_title'
                      )
                    "
                    class="w-full"
                    v-model.trim="model.dashboard_ad_link2_title"
                  />
                </div>
              </div>
              <div class="w-full flex flex-row pb-4">
                <div class="w-1/5 flex flex-col">
                  <label class="font-semibold text-sm text-grey-700 mr-2">
                    {{
                      $t(
                        'frontend_baselayout_dashboard_setting_dashboard_ad_link2'
                      )
                    }}</label
                  >
                </div>
                <div class="w-1/2 flex flex-col">
                  <text-input
                    :placeholder="
                      $t(
                        'frontend_baselayout_dashboard_setting_dashboard_ad_link2'
                      )
                    "
                    class="w-full"
                    v-model.trim="model.dashboard_ad_link2"
                  />
                </div>
              </div>
              <div class="w-full flex flex-row pb-4">
                <div class="w-1/5 flex flex-col">
                  <label class="font-semibold text-sm text-grey-700 mr-2">
                    {{ $t('frontend_display') }}</label
                  >
                </div>
                <div class="w-1/2 flex flex-col">
                  <select
                    v-model="model.dashboard_ad_link2_display"
                    class="
                        h-10
                        outline-none
                        rounded-lg
                        border
                        px-2
                        border-grey-200
                        max-w-full
                    "
                    :value="model.dashboard_ad_link2_display"
                  >
                    <option value="0">{{
                      $t('frontend_gduikit_show_to_all')
                    }}</option>
                    <option value="1">{{
                      $t('frontend_gduikit_show_only_to_free')
                    }}</option>
                    <option value="2">{{
                      $t('frontend_gduikit_show_only_to_paid')
                    }}</option>
                  </select>
                </div>
              </div>

              <!-- Link 3 -->
              <div
                class="w-full flex flex-row pb-4"
                v-if="model.dashboard_ad_type == 1"
              >
                <div class="w-1/5 flex flex-col">
                  <label class="font-semibold text-sm text-grey-700 mr-2">
                    {{
                      $t(
                        'frontend_baselayout_dashboard_setting_dashboard_ad_link3_image'
                      )
                    }}</label
                  >
                </div>
                <div class="w-1/2 flex flex-col">
                  <image-picker
                    v-model="model.dashboard_ad_link3_image"
                    :primary="true"
                  ></image-picker>
                </div>
              </div>
              <div class="w-full flex flex-row pb-4" v-else>
                <div class="w-1/5 flex flex-col">
                  <label class="font-semibold text-sm text-grey-700 mr-2">
                    {{
                      $t(
                        'frontend_baselayout_dashboard_setting_dashboard_ad_link3_title'
                      )
                    }}</label
                  >
                </div>
                <div class="w-1/2 flex flex-col">
                  <text-input
                    :placeholder="
                      $t(
                        'frontend_baselayout_dashboard_setting_dashboard_ad_link3_title'
                      )
                    "
                    class="w-full"
                    v-model.trim="model.dashboard_ad_link3_title"
                  />
                </div>
              </div>
              <div class="w-full flex flex-row pb-4">
                <div class="w-1/5 flex flex-col">
                  <label class="font-semibold text-sm text-grey-700 mr-2">
                    {{
                      $t(
                        'frontend_baselayout_dashboard_setting_dashboard_ad_link3'
                      )
                    }}</label
                  >
                </div>
                <div class="w-1/2 flex flex-col">
                  <text-input
                    :placeholder="
                      $t(
                        'frontend_baselayout_dashboard_setting_dashboard_ad_link3'
                      )
                    "
                    class="w-full"
                    v-model.trim="model.dashboard_ad_link3"
                  />
                </div>
              </div>
              <div class="w-full flex flex-row pb-4">
                <div class="w-1/5 flex flex-col">
                  <label class="font-semibold text-sm text-grey-700 mr-2">
                    {{ $t('frontend_display') }}</label
                  >
                </div>
                <div class="w-1/2 flex flex-col">
                  <select
                    v-model="model.dashboard_ad_link3_display"
                    class="
                        h-10
                        outline-none
                        rounded-lg
                        border
                        px-2
                        border-grey-200
                        max-w-full
                    "
                    :value="model.dashboard_ad_link3_display"
                  >
                    <option value="0">{{
                      $t('frontend_gduikit_show_to_all')
                    }}</option>
                    <option value="1">{{
                      $t('frontend_gduikit_show_only_to_free')
                    }}</option>
                    <option value="2">{{
                      $t('frontend_gduikit_show_only_to_paid')
                    }}</option>
                  </select>
                </div>
              </div>

              <!-- Link 4 -->
              <div
                class="w-full flex flex-row pb-4"
                v-if="model.dashboard_ad_type == 1"
              >
                <div class="w-1/5 flex flex-col">
                  <label class="font-semibold text-sm text-grey-700 mr-2">
                    {{
                      $t(
                        'frontend_baselayout_dashboard_setting_dashboard_ad_link4_image'
                      )
                    }}</label
                  >
                </div>
                <div class="w-1/2 flex flex-col">
                  <image-picker
                    v-model="model.dashboard_ad_link4_image"
                    :primary="true"
                  ></image-picker>
                </div>
              </div>
              <div class="w-full flex flex-row pb-4" v-else>
                <div class="w-1/5 flex flex-col">
                  <label class="font-semibold text-sm text-grey-700 mr-2">
                    {{
                      $t(
                        'frontend_baselayout_dashboard_setting_dashboard_ad_link4_title'
                      )
                    }}</label
                  >
                </div>
                <div class="w-1/2 flex flex-col">
                  <text-input
                    :placeholder="
                      $t(
                        'frontend_baselayout_dashboard_setting_dashboard_ad_link4_title'
                      )
                    "
                    class="w-full"
                    v-model.trim="model.dashboard_ad_link4_title"
                  />
                </div>
              </div>
              <div class="w-full flex flex-row pb-4">
                <div class="w-1/5 flex flex-col">
                  <label class="font-semibold text-sm text-grey-700 mr-2">
                    {{
                      $t(
                        'frontend_baselayout_dashboard_setting_dashboard_ad_link4'
                      )
                    }}</label
                  >
                </div>
                <div class="w-1/2 flex flex-col">
                  <text-input
                    :placeholder="
                      $t(
                        'frontend_baselayout_dashboard_setting_dashboard_ad_link4'
                      )
                    "
                    class="w-full"
                    v-model.trim="model.dashboard_ad_link4"
                  />
                </div>
              </div>
              <div class="w-full flex flex-row pb-4">
                <div class="w-1/5 flex flex-col">
                  <label class="font-semibold text-sm text-grey-700 mr-2">
                    {{ $t('frontend_display') }}</label
                  >
                </div>
                <div class="w-1/2 flex flex-col">
                  <select
                    v-model="model.dashboard_ad_link4_display"
                    class="
                        h-10
                        outline-none
                        rounded-lg
                        border
                        px-2
                        border-grey-200
                        max-w-full
                    "
                    :value="model.dashboard_ad_link4_display"
                  >
                    <option value="0">{{
                      $t('frontend_gduikit_show_to_all')
                    }}</option>
                    <option value="1">{{
                      $t('frontend_gduikit_show_only_to_free')
                    }}</option>
                    <option value="2">{{
                      $t('frontend_gduikit_show_only_to_paid')
                    }}</option>
                  </select>
                </div>
              </div>

              <!-- Link 5 -->
              <div
                class="w-full flex flex-row pb-4"
                v-if="model.dashboard_ad_type == 1"
              >
                <div class="w-1/5 flex flex-col">
                  <label class="font-semibold text-sm text-grey-700 mr-2">
                    {{
                      $t(
                        'frontend_baselayout_dashboard_setting_dashboard_ad_link5_image'
                      )
                    }}</label
                  >
                </div>
                <div class="w-1/2 flex flex-col">
                  <image-picker
                    v-model="model.dashboard_ad_link5_image"
                    :primary="true"
                  ></image-picker>
                </div>
              </div>
              <div class="w-full flex flex-row pb-4" v-else>
                <div class="w-1/5 flex flex-col">
                  <label class="font-semibold text-sm text-grey-700 mr-2">
                    {{
                      $t(
                        'frontend_baselayout_dashboard_setting_dashboard_ad_link5_title'
                      )
                    }}</label
                  >
                </div>
                <div class="w-1/2 flex flex-col">
                  <text-input
                    :placeholder="
                      $t(
                        'frontend_baselayout_dashboard_setting_dashboard_ad_link5_title'
                      )
                    "
                    class="w-full"
                    v-model.trim="model.dashboard_ad_link5_title"
                  />
                </div>
              </div>
              <div class="w-full flex flex-row pb-4">
                <div class="w-1/5 flex flex-col">
                  <label class="font-semibold text-sm text-grey-700 mr-2">
                    {{
                      $t(
                        'frontend_baselayout_dashboard_setting_dashboard_ad_link5'
                      )
                    }}</label
                  >
                </div>
                <div class="w-1/2 flex flex-col">
                  <text-input
                    :placeholder="
                      $t(
                        'frontend_baselayout_dashboard_setting_dashboard_ad_link5'
                      )
                    "
                    class="w-full"
                    v-model.trim="model.dashboard_ad_link5"
                  />
                </div>
              </div>
              <div class="w-full flex flex-row pb-4">
                <div class="w-1/5 flex flex-col">
                  <label class="font-semibold text-sm text-grey-700 mr-2">
                    {{ $t('frontend_display') }}</label
                  >
                </div>
                <div class="w-1/2 flex flex-col">
                  <select
                    v-model="model.dashboard_ad_link5_display"
                    class="
                        h-10
                        outline-none
                        rounded-lg
                        border
                        px-2
                        border-grey-200
                        max-w-full
                    "
                    :value="model.dashboard_ad_link5_display"
                  >
                    <option value="0">{{
                      $t('frontend_gduikit_show_to_all')
                    }}</option>
                    <option value="1">{{
                      $t('frontend_gduikit_show_only_to_free')
                    }}</option>
                    <option value="2">{{
                      $t('frontend_gduikit_show_only_to_paid')
                    }}</option>
                  </select>
                </div>
              </div>

              <!-- Link 6 -->
              <div
                class="w-full flex flex-row pb-4"
                v-if="model.dashboard_ad_type == 1"
              >
                <div class="w-1/5 flex flex-col">
                  <label class="font-semibold text-sm text-grey-700 mr-2">
                    {{
                      $t(
                        'frontend_baselayout_dashboard_setting_dashboard_ad_link6_image'
                      )
                    }}</label
                  >
                </div>
                <div class="w-1/2 flex flex-col">
                  <image-picker
                    v-model="model.dashboard_ad_link6_image"
                    :primary="true"
                  ></image-picker>
                </div>
              </div>
              <div class="w-full flex flex-row pb-4" v-else>
                <div class="w-1/5 flex flex-col">
                  <label class="font-semibold text-sm text-grey-700 mr-2">
                    {{
                      $t(
                        'frontend_baselayout_dashboard_setting_dashboard_ad_link6_title'
                      )
                    }}</label
                  >
                </div>
                <div class="w-1/2 flex flex-col">
                  <text-input
                    :placeholder="
                      $t(
                        'frontend_baselayout_dashboard_setting_dashboard_ad_link6_title'
                      )
                    "
                    class="w-full"
                    v-model.trim="model.dashboard_ad_link6_title"
                  />
                </div>
              </div>
              <div class="w-full flex flex-row pb-4">
                <div class="w-1/5 flex flex-col">
                  <label class="font-semibold text-sm text-grey-700 mr-2">
                    {{
                      $t(
                        'frontend_baselayout_dashboard_setting_dashboard_ad_link6'
                      )
                    }}</label
                  >
                </div>
                <div class="w-1/2 flex flex-col">
                  <text-input
                    :placeholder="
                      $t(
                        'frontend_baselayout_dashboard_setting_dashboard_ad_link6'
                      )
                    "
                    class="w-full"
                    v-model.trim="model.dashboard_ad_link6"
                  />
                </div>
              </div>
              <div class="w-full flex flex-row pb-4">
                <div class="w-1/5 flex flex-col">
                  <label class="font-semibold text-sm text-grey-700 mr-2">
                    {{ $t('frontend_display') }}</label
                  >
                </div>
                <div class="w-1/2 flex flex-col">
                  <select
                    v-model="model.dashboard_ad_link6_display"
                    class="
                        h-10
                        outline-none
                        rounded-lg
                        border
                        px-2
                        border-grey-200
                        max-w-full
                    "
                    :value="model.dashboard_ad_link6_display"
                  >
                    <option value="0">{{
                      $t('frontend_gduikit_show_to_all')
                    }}</option>
                    <option value="1">{{
                      $t('frontend_gduikit_show_only_to_free')
                    }}</option>
                    <option value="2">{{
                      $t('frontend_gduikit_show_only_to_paid')
                    }}</option>
                  </select>
                </div>
              </div>

              <!-- Link 7 -->
              <div
                class="w-full flex flex-row pb-4"
                v-if="model.dashboard_ad_type == 1"
              >
                <div class="w-1/5 flex flex-col">
                  <label class="font-semibold text-sm text-grey-700 mr-2">
                    {{
                      $t(
                        'frontend_baselayout_dashboard_setting_dashboard_ad_link7_image'
                      )
                    }}</label
                  >
                </div>
                <div class="w-1/2 flex flex-col">
                  <image-picker
                    v-model="model.dashboard_ad_link7_image"
                    :primary="true"
                  ></image-picker>
                </div>
              </div>
              <div class="w-full flex flex-row pb-4" v-else>
                <div class="w-1/5 flex flex-col">
                  <label class="font-semibold text-sm text-grey-700 mr-2">
                    {{
                      $t(
                        'frontend_baselayout_dashboard_setting_dashboard_ad_link7_title'
                      )
                    }}</label
                  >
                </div>
                <div class="w-1/2 flex flex-col">
                  <text-input
                    :placeholder="
                      $t(
                        'frontend_baselayout_dashboard_setting_dashboard_ad_link7_title'
                      )
                    "
                    class="w-full"
                    v-model.trim="model.dashboard_ad_link7_title"
                  />
                </div>
              </div>
              <div class="w-full flex flex-row pb-4">
                <div class="w-1/5 flex flex-col">
                  <label class="font-semibold text-sm text-grey-700 mr-2">
                    {{
                      $t(
                        'frontend_baselayout_dashboard_setting_dashboard_ad_link7'
                      )
                    }}</label
                  >
                </div>
                <div class="w-1/2 flex flex-col">
                  <text-input
                    :placeholder="
                      $t(
                        'frontend_baselayout_dashboard_setting_dashboard_ad_link7'
                      )
                    "
                    class="w-full"
                    v-model.trim="model.dashboard_ad_link7"
                  />
                </div>
              </div>
              <div class="w-full flex flex-row pb-4">
                <div class="w-1/5 flex flex-col">
                  <label class="font-semibold text-sm text-grey-700 mr-2">
                    {{ $t('frontend_display') }}</label
                  >
                </div>
                <div class="w-1/2 flex flex-col">
                  <select
                    v-model="model.dashboard_ad_link7_display"
                    class="
                        h-10
                        outline-none
                        rounded-lg
                        border
                        px-2
                        border-grey-200
                        max-w-full
                    "
                    :value="model.dashboard_ad_link7_display"
                  >
                    <option value="0">{{
                      $t('frontend_gduikit_show_to_all')
                    }}</option>
                    <option value="1">{{
                      $t('frontend_gduikit_show_only_to_free')
                    }}</option>
                    <option value="2">{{
                      $t('frontend_gduikit_show_only_to_paid')
                    }}</option>
                  </select>
                </div>
              </div>

              <!-- Link 8 -->
              <div
                class="w-full flex flex-row pb-4"
                v-if="model.dashboard_ad_type == 1"
              >
                <div class="w-1/5 flex flex-col">
                  <label class="font-semibold text-sm text-grey-700 mr-2">
                    {{
                      $t(
                        'frontend_baselayout_dashboard_setting_dashboard_ad_link8_image'
                      )
                    }}</label
                  >
                </div>
                <div class="w-1/2 flex flex-col">
                  <image-picker
                    v-model="model.dashboard_ad_link8_image"
                    :primary="true"
                  ></image-picker>
                </div>
              </div>
              <div class="w-full flex flex-row pb-4" v-else>
                <div class="w-1/5 flex flex-col">
                  <label class="font-semibold text-sm text-grey-700 mr-2">
                    {{
                      $t(
                        'frontend_baselayout_dashboard_setting_dashboard_ad_link8_title'
                      )
                    }}</label
                  >
                </div>
                <div class="w-1/2 flex flex-col">
                  <text-input
                    :placeholder="
                      $t(
                        'frontend_baselayout_dashboard_setting_dashboard_ad_link8_title'
                      )
                    "
                    class="w-full"
                    v-model.trim="model.dashboard_ad_link8_title"
                  />
                </div>
              </div>
              <div class="w-full flex flex-row pb-4">
                <div class="w-1/5 flex flex-col">
                  <label class="font-semibold text-sm text-grey-700 mr-2">
                    {{
                      $t(
                        'frontend_baselayout_dashboard_setting_dashboard_ad_link8'
                      )
                    }}</label
                  >
                </div>
                <div class="w-1/2 flex flex-col">
                  <text-input
                    :placeholder="
                      $t(
                        'frontend_baselayout_dashboard_setting_dashboard_ad_link8'
                      )
                    "
                    class="w-full"
                    v-model.trim="model.dashboard_ad_link8"
                  />
                </div>
              </div>
              <div class="w-full flex flex-row pb-4">
                <div class="w-1/5 flex flex-col">
                  <label class="font-semibold text-sm text-grey-700 mr-2">
                    {{ $t('frontend_display') }}</label
                  >
                </div>
                <div class="w-1/2 flex flex-col">
                  <select
                    v-model="model.dashboard_ad_link8_display"
                    class="
                        h-10
                        outline-none
                        rounded-lg
                        border
                        px-2
                        border-grey-200
                        max-w-full
                    "
                    :value="model.dashboard_ad_link8_display"
                  >
                    <option value="0">{{
                      $t('frontend_gduikit_show_to_all')
                    }}</option>
                    <option value="1">{{
                      $t('frontend_gduikit_show_only_to_free')
                    }}</option>
                    <option value="2">{{
                      $t('frontend_gduikit_show_only_to_paid')
                    }}</option>
                  </select>
                </div>
              </div>
            </div>
            <div v-else>
              <div class="w-full flex flex-row pb-4">
                <div class="w-1/5 flex flex-col">
                  <label class="font-semibold text-sm text-grey-700 mr-2">
                    IFrame URL
                  </label>
                </div>
                <div class="w-1/2 flex flex-col">
                  <text-input
                    placeholder="IFrame URL"
                    class="w-full"
                    v-model.trim="model.dashboard_ad_iframe_url"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </gd-modal>
</template>

<script>
import api from '@groovepages/gd-lib/api';
import Notify from '../notify';
import getVideoId from 'get-video-id';
import GdButton from './Button';
import ConfirmModal from './ConfirmModal';
import DropMenu from './DropMenu';
import GdDropdown from './Dropdown';
import ImagePicker from './ImagePickerModal';
import InfoPanel from './InfoPanel';
import GdModal from './Modal';
import SideBar from './SideBar';
import TextInput from './TextInput';

export default {
  name: 'DashboardSetting',
  components: {
    GdButton,
    TextInput,
    DropMenu,
    GdDropdown,
    SideBar,
    InfoPanel,
    GdModal,
    ConfirmModal,
    ImagePicker
  },
  data() {
    return {
      model: {
        id: 0,
        is_dashboard_ad_enabled: 0,
        dashboard_setting_type: 1,
        dashboard_ad_iframe_url: '',
        dashboard_ad_video_provider: '',
        dashboard_ad_video_id: '',
        dashboard_ad_paid_video_provider: '',
        dashboard_ad_paid_video_id: '',
        dashboard_ad_heading: '',
        dashboard_ad_description: '',
        dashboard_ad_type: 0,
        dashboard_ad_link1_image: '',
        dashboard_ad_link1_title: '',
        dashboard_ad_link1: '',
        dashboard_ad_link1_display: 0,
        dashboard_ad_link2_image: '',
        dashboard_ad_link2_title: '',
        dashbaord_ad_link2: '',
        dashboard_ad_link2_display: 0,
        dashboard_ad_link3_image: '',
        dashboard_ad_link3_title: '',
        dashboard_ad_link3: '',
        dashboard_ad_link3_display: 0,
        dashboard_ad_link4_image: '',
        dashboard_ad_link4_title: '',
        dashboard_ad_link4: '',
        dashboard_ad_link4_display: 0,
        dashboard_ad_link5_image: '',
        dashboard_ad_link5_title: '',
        dashboard_ad_link5: '',
        dashboard_ad_link5_display: 0,
        dashboard_ad_link6_image: '',
        dashboard_ad_link6_title: '',
        dashboard_ad_link6: '',
        dashboard_ad_link6_display: 0,
        dashboard_ad_link7_image: '',
        dashboard_ad_link7_title: '',
        dashboard_ad_link7: '',
        dashboard_ad_link7_display: 0,
        dashboard_ad_link8_image: '',
        dashboard_ad_link8_title: '',
        dashboard_ad_link8: '',
        dashboard_ad_link8_display: 0
      },
      url: '',
      image: '',
      status: '',
      toEdit: '',
      toDelete: '',
      toStatus: '',
      messageStatus: ''
    };
  },
  computed: {
    isValid() {
      if (this.image && this.url) return true;
      return false;
    },
    sidebarTitle() {
      if (!this.toEdit) return this.$t('frontend_add');
      return this.$t('frontend_edit');
    }
  },
  methods: {
    open() {
      this.initDashboardSettings();
      this.$root.$emit('modal-open', 'dashboard-setting');
    },
    close() {
      this.$root.$emit('modal-close', 'dashboard-setting');
    },
    async initDashboardSettings() {
      await api
        .get(`${window.gdEnv.VUE_APP_API_URL}/groovesell/dashboard-setting`)
        .then(data => {
          if (data.status) {
            this.model.id = data.data.id;
            this.model.is_dashboard_ad_enabled =
              data.data.value.is_dashboard_ad_enabled;
            this.model.dashboard_ad_heading =
              data.data.value.dashboard_ad_heading;
            this.model.dashboard_ad_description =
              data.data.value.dashboard_ad_description;
            this.model.dashboard_setting_type =
              data.data.value.dashboard_setting_type;
            this.model.dashboard_ad_iframe_url =
              data.data.value.dashboard_ad_iframe_url;
            this.model.dashboard_ad_type = data.data.value.dashboard_ad_type;
            this.model.dashboard_ad_video_embed =
              data.data.value.dashboard_ad_video_provider == 'groovevideo'
                ? data.data.value.dashboard_ad_video_id
                : `https://www.youtube.com/watch?v=${data.data.value.dashboard_ad_video_id}`;
            this.model.dashboard_ad_paid_video_embed =
              data.data.value.dashboard_ad_paid_video_provider ==
                'groovevideo' ||
              !data.data.value.dashboard_ad_paid_video_provider
                ? data.data.value.dashboard_ad_paid_video_id
                  ? data.data.value.dashboard_ad_paid_video_id
                  : ''
                : `https://www.youtube.com/watch?v=${data.data.value.dashboard_ad_paid_video_id}`;
            this.model.dashboard_ad_link1_image =
              data.data.value.dashboard_ad_link1_image;
            this.model.dashboard_ad_link1_title =
              data.data.value.dashboard_ad_link1_title;
            this.model.dashboard_ad_link1 = data.data.value.dashboard_ad_link1;
            this.model.dashboard_ad_link1_display =
              data.data.value.dashboard_ad_link1_display;
            this.model.dashboard_ad_link2_image =
              data.data.value.dashboard_ad_link2_image;
            this.model.dashboard_ad_link2_title =
              data.data.value.dashboard_ad_link2_title;
            this.model.dashboard_ad_link2 = data.data.value.dashboard_ad_link2;
            this.model.dashboard_ad_link2_display =
              data.data.value.dashboard_ad_link2_display;
            this.model.dashboard_ad_link3_image =
              data.data.value.dashboard_ad_link3_image;
            this.model.dashboard_ad_link3_title =
              data.data.value.dashboard_ad_link3_title;
            this.model.dashboard_ad_link3 = data.data.value.dashboard_ad_link3;
            this.model.dashboard_ad_link3_display =
              data.data.value.dashboard_ad_link3_display;
            this.model.dashboard_ad_link4_image =
              data.data.value.dashboard_ad_link4_image;
            this.model.dashboard_ad_link4_title =
              data.data.value.dashboard_ad_link4_title;
            this.model.dashboard_ad_link4 = data.data.value.dashboard_ad_link4;
            this.model.dashboard_ad_link4_display =
              data.data.value.dashboard_ad_link4_display;
            this.model.dashboard_ad_link5_image =
              data.data.value.dashboard_ad_link5_image;
            this.model.dashboard_ad_link5_title =
              data.data.value.dashboard_ad_link5_title;
            this.model.dashboard_ad_link5 = data.data.value.dashboard_ad_link5;
            this.model.dashboard_ad_link5_display =
              data.data.value.dashboard_ad_link5_display;
            this.model.dashboard_ad_link6_image =
              data.data.value.dashboard_ad_link6_image;
            this.model.dashboard_ad_link6_title =
              data.data.value.dashboard_ad_link6_title;
            this.model.dashboard_ad_link6 = data.data.value.dashboard_ad_link6;
            this.model.dashboard_ad_link6_display =
              data.data.value.dashboard_ad_link6_display;
            this.model.dashboard_ad_link7_image =
              data.data.value.dashboard_ad_link7_image;
            this.model.dashboard_ad_link7_title =
              data.data.value.dashboard_ad_link7_title;
            this.model.dashboard_ad_link7 = data.data.value.dashboard_ad_link7;
            this.model.dashboard_ad_link7_display =
              data.data.value.dashboard_ad_link7_display;
            this.model.dashboard_ad_link8_image =
              data.data.value.dashboard_ad_link8_image;
            this.model.dashboard_ad_link8_title =
              data.data.value.dashboard_ad_link8_title;
            this.model.dashboard_ad_link8 = data.data.value.dashboard_ad_link8;
            this.model.dashboard_ad_link8_display =
              data.data.value.dashboard_ad_link8_display;
          }
          console.log('this.model', this.model);
        })
        .catch(err => this.showError(err));
    },

    UpdateAddSetting() {
      let videoDetails = null;
      if (this.model.dashboard_ad_video_embed.includes('groovevideo')) {
        videoDetails = {
          id: this.model.dashboard_ad_video_embed,
          service: 'groovevideo'
        };
      } else {
        videoDetails = getVideoId(this.model.dashboard_ad_video_embed);
      }

      console.log('these are the videodeatils');
      console.log(videoDetails);

      if (!videoDetails || !videoDetails.id || !videoDetails.service) {
        return false;
      }

      console.log('paid embed' + this.model.dashboard_ad_paid_video_embed);
      let paidVideoDetails = null;

      if (
        this.model.dashboard_ad_paid_video_embed &&
        this.model.dashboard_ad_paid_video_embed.includes('groovevideo')
      ) {
        console.log('inside groovevideo.com');
        paidVideoDetails = {
          id: this.model.dashboard_ad_paid_video_embed,
          service: 'groovevideo'
        };
      } else {
        paidVideoDetails = getVideoId(this.model.dashboard_ad_paid_video_embed);
      }

      if (this.model.id == 0) {
        api
          .post(
            `${window.gdEnv.VUE_APP_API_URL}/groovesell/dashboard-setting-save`,
            {
              is_dashboard_ad_enabled: this.model.is_dashboard_ad_enabled,
              dashboard_ad_heading: this.model.dashboard_ad_heading,
              dashboard_ad_description: this.model.dashboard_ad_description,
              dashboard_ad_type: this.model.dashboard_ad_type,
              dashboard_setting_type: this.model.dashboard_setting_type,
              dashboard_ad_iframe_url: this.model.dashboard_ad_iframe_url,
              dashboard_ad_video_provider: videoDetails.service,
              dashboard_ad_video_id: videoDetails.id,
              dashboard_ad_paid_video_provider: paidVideoDetails.service,
              dashboard_ad_paid_video_id: paidVideoDetails.id,
              dashboard_ad_link1_image: this.model.dashboard_ad_link1_image,
              dashboard_ad_link1_title: this.model.dashboard_ad_link1_title,
              dashboard_ad_link1: this.model.dashboard_ad_link1,
              dashboard_ad_link1_display: this.model.dashboard_ad_link1_display,
              dashboard_ad_link2_image: this.model.dashboard_ad_link2_image,
              dashboard_ad_link2_title: this.model.dashboard_ad_link2_title,
              dashboard_ad_link2: this.model.dashboard_ad_link2,
              dashboard_ad_link2_display: this.model.dashboard_ad_link2_display,
              dashboard_ad_link3_image: this.model.dashboard_ad_link3_image,
              dashboard_ad_link3_title: this.model.dashboard_ad_link3_title,
              dashboard_ad_link3: this.model.dashboard_ad_link3,
              dashboard_ad_link3_display: this.model.dashboard_ad_link3_display,
              dashboard_ad_link4_image: this.model.dashboard_ad_link4_image,
              dashboard_ad_link4_title: this.model.dashboard_ad_link4_title,
              dashboard_ad_link4: this.model.dashboard_ad_link4,
              dashboard_ad_link4_display: this.model.dashboard_ad_link4_display,
              dashboard_ad_link5_image: this.model.dashboard_ad_link5_image,
              dashboard_ad_link5_title: this.model.dashboard_ad_link5_title,
              dashboard_ad_link5: this.model.dashboard_ad_link5,
              dashboard_ad_link5_display: this.model.dashboard_ad_link5_display,
              dashboard_ad_link6_image: this.model.dashboard_ad_link6_image,
              dashboard_ad_link6_title: this.model.dashboard_ad_link6_title,
              dashboard_ad_link6: this.model.dashboard_ad_link6,
              dashboard_ad_link6_display: this.model.dashboard_ad_link6_display,
              dashboard_ad_link7_image: this.model.dashboard_ad_link7_image,
              dashboard_ad_link7_title: this.model.dashboard_ad_link7_title,
              dashboard_ad_link7: this.model.dashboard_ad_link7,
              dashboard_ad_link7_display: this.model.dashboard_ad_link7_display,
              dashboard_ad_link8_image: this.model.dashboard_ad_link8_image,
              dashboard_ad_link8_title: this.model.dashboard_ad_link8_title,
              dashboard_ad_link8: this.model.dashboard_ad_link8,
              dashboard_ad_link8_display: this.model.dashboard_ad_link8_display
            }
          )
          .then(data => {
            this.showSuccess(data);
            location.reload();
          })
          .catch(err => this.showError(err));
      } else {
        api
          .post(
            `${window.gdEnv.VUE_APP_API_URL}/groovesell/dashboard-setting-update`,
            {
              id: this.model.id,
              is_dashboard_ad_enabled: this.model.is_dashboard_ad_enabled,
              dashboard_ad_heading: this.model.dashboard_ad_heading,
              dashboard_ad_description: this.model.dashboard_ad_description,
              dashboard_ad_type: this.model.dashboard_ad_type,
              dashboard_setting_type: this.model.dashboard_setting_type,
              dashboard_ad_iframe_url: this.model.dashboard_ad_iframe_url,
              dashboard_ad_video_provider: videoDetails.service,
              dashboard_ad_video_id: videoDetails.id,
              dashboard_ad_paid_video_provider: paidVideoDetails.service,
              dashboard_ad_paid_video_id: paidVideoDetails.id,
              dashboard_ad_link1_image: this.model.dashboard_ad_link1_image,
              dashboard_ad_link1_title: this.model.dashboard_ad_link1_title,
              dashboard_ad_link1: this.model.dashboard_ad_link1,
              dashboard_ad_link1_display: this.model.dashboard_ad_link1_display,
              dashboard_ad_link2_image: this.model.dashboard_ad_link2_image,
              dashboard_ad_link2_title: this.model.dashboard_ad_link2_title,
              dashboard_ad_link2: this.model.dashboard_ad_link2,
              dashboard_ad_link2_display: this.model.dashboard_ad_link2_display,
              dashboard_ad_link3_image: this.model.dashboard_ad_link3_image,
              dashboard_ad_link3_title: this.model.dashboard_ad_link3_title,
              dashboard_ad_link3: this.model.dashboard_ad_link3,
              dashboard_ad_link3_display: this.model.dashboard_ad_link3_display,
              dashboard_ad_link4_image: this.model.dashboard_ad_link4_image,
              dashboard_ad_link4_title: this.model.dashboard_ad_link4_title,
              dashboard_ad_link4: this.model.dashboard_ad_link4,
              dashboard_ad_link4_display: this.model.dashboard_ad_link4_display,
              dashboard_ad_link5_image: this.model.dashboard_ad_link5_image,
              dashboard_ad_link5_title: this.model.dashboard_ad_link5_title,
              dashboard_ad_link5: this.model.dashboard_ad_link5,
              dashboard_ad_link5_display: this.model.dashboard_ad_link5_display,
              dashboard_ad_link6_image: this.model.dashboard_ad_link6_image,
              dashboard_ad_link6_title: this.model.dashboard_ad_link6_title,
              dashboard_ad_link6: this.model.dashboard_ad_link6,
              dashboard_ad_link6_display: this.model.dashboard_ad_link6_display,
              dashboard_ad_link7_image: this.model.dashboard_ad_link7_image,
              dashboard_ad_link7_title: this.model.dashboard_ad_link7_title,
              dashboard_ad_link7: this.model.dashboard_ad_link7,
              dashboard_ad_link7_display: this.model.dashboard_ad_link7_display,
              dashboard_ad_link8_image: this.model.dashboard_ad_link8_image,
              dashboard_ad_link8_title: this.model.dashboard_ad_link8_title,
              dashboard_ad_link8: this.model.dashboard_ad_link8,
              dashboard_ad_link8_display: this.model.dashboard_ad_link8_display
            }
          )
          .then(data => {
            this.showSuccess(data);
            location.reload();
          })
          .catch(err => this.showError(err));
      }
      this.close();
    },

    showSuccess(data) {
      this.initDashboardSettings();
      return Notify.success('Success');
    },
    showError(err) {
      return Notify.fail(err.message || 'Error');
    }
  }
};
</script>
